/**
 * Русский частотный список, упорядоченный по убыванию употребительности.
 *
 * Состав ограничен общеупотребительной нейтральной лексикой: она даёт
 * максимальный перенос навыка в реальный текст (ТЗ §4.6).
 */

export const RU_WORD_LIST: readonly string[] = [
  'и',
  'в',
  'не',
  'на',
  'я',
  'быть',
  'он',
  'с',
  'что',
  'а',
  'по',
  'это',
  'она',
  'этот',
  'к',
  'но',
  'они',
  'мы',
  'как',
  'из',
  'у',
  'который',
  'то',
  'за',
  'свой',
  'весь',
  'год',
  'от',
  'так',
  'для',
  'о',
  'же',
  'вы',
  'человек',
  'один',
  'ещё',
  'бы',
  'такой',
  'только',
  'себя',
  'своё',
  'какой',
  'когда',
  'уже',
  'если',
  'дело',
  'время',
  'рука',
  'нет',
  'самый',
  'ни',
  'стать',
  'большой',
  'даже',
  'другой',
  'наш',
  'свои',
  'под',
  'мочь',
  'ваш',
  'знать',
  'говорить',
  'да',
  'вот',
  'сам',
  'чтобы',
  'без',
  'первый',
  'между',
  'жизнь',
  'день',
  'тут',
  'во',
  'ничто',
  'потом',
  'очень',
  'со',
  'хотеть',
  'ли',
  'при',
  'голова',
  'надо',
  'видеть',
  'идти',
  'теперь',
  'тоже',
  'стоять',
  'друг',
  'дом',
  'сейчас',
  'можно',
  'после',
  'слово',
  'здесь',
  'думать',
  'место',
  'спросить',
  'через',
  'лицо',
  'тогда',
  'ведь',
  'хороший',
  'простой',
  'русский',
  'вода',
  'ребёнок',
  'конец',
  'сделать',
  'лежать',
  'нужно',
  'почти',
  'ответить',
  'начать',
  'страна',
  'мир',
  'работа',
  'земля',
  'город',
  'вопрос',
  'система',
  'сила',
  'книга',
  'сторона',
  'часть',
  'путь',
  'глаз',
  'ночь',
  'форма',
  'вид',
  'общий',
  'новый',
  'старый',
  'молодой',
  'долгий',
  'важный',
  'разный',
  'белый',
  'чёрный',
  'красный',
  'зелёный',
  'быстрый',
  'лёгкий',
  'тяжёлый',
  'светлый',
  'тёмный',
  'тёплый',
  'холодный',
  'сильный',
  'писать',
  'читать',
  'учить',
  'считать',
  'искать',
  'найти',
  'дать',
  'взять',
  'ждать',
  'помнить',
  'жить',
  'работать',
  'учиться',
  'играть',
  'смотреть',
  'слушать',
  'понять',
  'решить',
  'открыть',
  'закрыть',
  'сегодня',
  'завтра',
  'вчера',
  'утро',
  'вечер',
  'неделя',
  'месяц',
  'минута',
  'час',
  'сначала',
  'вместе',
  'всегда',
  'никогда',
  'иногда',
  'снова',
  'рядом',
  'вперёд',
  'назад',
  'вокруг',
  'внутри',
  'ключ',
  'экран',
  'буква',
  'строка',
  'ошибка',
  'скорость',
  'точность',
  'привычка',
  'память',
  'внимание',
  // Дальше — слова, добавленные ради разнообразия материала (этап ABL).
  // Порядок внутри блока приблизительный: это хвост частотного списка, и
  // точный ранг здесь ничего не решает. Короткие слова в конце блока набраны
  // буквами домашнего ряда и первых открываемых групп: без них у новичка на
  // десяти клавишах не набиралось и десятка слов.
  'случай',
  'причина',
  'пример',
  'правило',
  'способ',
  'решение',
  'значение',
  'условие',
  'качество',
  'опыт',
  'движение',
  'порядок',
  'проверка',
  'занятие',
  'урок',
  'задача',
  'цель',
  'план',
  'шаг',
  'ряд',
  'группа',
  'число',
  'счёт',
  'мера',
  'уровень',
  'предел',
  'запас',
  'остаток',
  'начало',
  'середина',
  'край',
  'дорога',
  'улица',
  'двор',
  'сад',
  'лес',
  'поле',
  'река',
  'море',
  'берег',
  'гора',
  'небо',
  'солнце',
  'ветер',
  'дождь',
  'снег',
  'лёд',
  'огонь',
  'свет',
  'тень',
  'звук',
  'голос',
  'шум',
  'запах',
  'вкус',
  'хлеб',
  'соль',
  'чай',
  'молоко',
  'обед',
  'ужин',
  'стол',
  'стул',
  'дверь',
  'окно',
  'стена',
  'пол',
  'потолок',
  'угол',
  'полка',
  'сумка',
  'карман',
  'бумага',
  'тетрадь',
  'ручка',
  'папка',
  'письмо',
  'газета',
  'журнал',
  'рассказ',
  'песня',
  'игра',
  'спорт',
  'бег',
  'сон',
  'отдых',
  'здоровье',
  'семья',
  'мама',
  'папа',
  'сестра',
  'брат',
  'сын',
  'дочь',
  'сосед',
  'гость',
  'врач',
  'учитель',
  'ученик',
  'мастер',
  'водитель',
  'сотрудник',
  'команда',
  'общество',
  'народ',
  'закон',
  'право',
  'договор',
  'цена',
  'деньги',
  'работник',
  'магазин',
  'товар',
  'выбор',
  'заказ',
  'адрес',
  'телефон',
  'письма',
  'ответ',
  'вопросы',
  'проект',
  'программа',
  'компьютер',
  'файл',
  'папки',
  'сеть',
  'сайт',
  'страница',
  'кнопка',
  'палец',
  'ладонь',
  'запястье',
  'осанка',
  'ритм',
  'темп',
  'пауза',
  'повтор',
  'разбор',
  'подход',
  'спокойно',
  'ровно',
  'точно',
  'легко',
  'трудно',
  'долго',
  'быстро',
  'медленно',
  'хорошо',
  'плохо',
  'важно',
  'просто',
  'сложно',
  'верно',
  'заново',
  'опять',
  'скоро',
  'поздно',
  'рано',
  'часто',
  'редко',
  'много',
  'мало',
  'больше',
  'меньше',
  'лучше',
  'хуже',
  'дальше',
  'ближе',
  'выше',
  'высокий',
  'низкий',
  'ниже',
  'держать',
  'ставить',
  'класть',
  'брать',
  'носить',
  'водить',
  'ходить',
  'бежать',
  'сидеть',
  'вставать',
  'падать',
  'расти',
  'менять',
  'править',
  'чинить',
  'строить',
  'ломать',
  'терять',
  'беречь',
  'ценить',
  'верить',
  'помогать',
  'мешать',
  'звать',
  'просить',
  'обещать',
  'молчать',
  'кричать',
  'шептать',
  'смеяться',
  'плакать',
  'дышать',
  'уставать',
  'отдыхать',
  'спешить',
  'пробовать',
  'проверять',
  'повторять',
  'запоминать',
  'забывать',
  'узнавать',
  'замечать',
  'выбирать',
  'сравнивать',
  'считаться',
  'два',
  'дважды',
  'воды',
  'вол',
  'вал',
  'валы',
  'дал',
  'дала',
  'дало',
  'лад',
  'лады',
  'жал',
  'жало',
  'жажда',
  'ждал',
  'ждала',
  'ложа',
  'лава',
  'овал',
  'вдова',
  'вывод',
  'выводы',
  'довод',
  'доводы',
  'выдал',
  'выдала',
  'вылов',
  'давал',
  'давала',
  'дол',
  'ода',
  'лов',
  'одна',
  'дно',
  'жена',
  'волна',
  'волны',
  'дела',
  'делал',
  'делала',
  'нежно',
  'ванна',
];
